var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GeniePrompt.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-27efd80a!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GeniePrompt.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/admin/GeniePrompt/GeniePrompt.vue
// module id = 1940
// module chunks = 61